const e = [
  "arrow-chevron-down",
  "arrow-chevron-left",
  "arrow-chevron-right",
  "arrow-chevron-up",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "basic-shape-diamond",
  "basic-shape-hexagon",
  "basic-shape-primary-circle-ellipse-round",
  "basic-shape-primary-square-rectangle",
  "basic-shape-shield",
  "computer-device-desktop-monitor",
  "computer-device-desktop",
  "computer-device-laptop",
  "computer-device-mobile-phone-android-samsung-back",
  "computer-device-mobile-phone-android-samsung",
  "computer-device-mobile-phone-iphone-x-back",
  "computer-device-mobile-phone-iphone-x",
  "computer-device-mobile-tablet-touch",
  "computer-device-mobile-tablet",
  "computer-device-network-ethernet-cat6",
  "computer-device-network-lan-www",
  "computer-device-network-wifi-connection",
  "computer-device-network-wifi-router",
  "computer-keyboard-alt",
  "computer-keyboard-command-cmd-control-ctrl",
  "computer-keyboard-option",
  "computer-keyboard-shift",
  "ecology-science-erlenmeyer-flask",
  "entertainment-control-button-circle-left-arrow-rewind",
  "entertainment-control-button-circle-pause",
  "entertainment-control-button-circle-right-arrow-fast-forward",
  "entertainment-control-button-circle-stop-square",
  "entertainment-control-button-play-circle",
  "entertainment-party-popper-confetti",
  "image-flash-lightning",
  "image-photo-frame",
  "image-picture-flower",
  "interface-add",
  "interface-alert-error-exclamation-block-square",
  "interface-alert-error-x-block-square",
  "interface-alert-exclamation-diamond",
  "interface-alert-exclamation-triangle-warning",
  "interface-alert-information-circle",
  "interface-award-crown",
  "interface-bookmark-tag",
  "interface-bookmark",
  "interface-calendar-date-one",
  "interface-close",
  "interface-content-book-open-pages",
  "interface-content-book-page",
  "interface-content-file",
  "interface-content-folder",
  "interface-copy-clipboard",
  "interface-delete-bin-trash",
  "interface-dots-horizontal",
  "interface-dots-vertical",
  "interface-edit-attachment",
  "interface-edit-binocular",
  "interface-edit-magic-wand",
  "interface-edit-tool-eraser",
  "interface-edit-tool-paint-brush",
  "interface-edit-tool-paint-roller",
  "interface-edit-tool-pen",
  "interface-edit-tool-pencil",
  "interface-edit-view-eye",
  "interface-favorite-award",
  "interface-favorite-flag",
  "interface-favorite-heart",
  "interface-favorite-star",
  "interface-favorite-stars-shining",
  "interface-favorite-stars-sparkles",
  "interface-hierarchy-flowchart",
  "interface-home-house",
  "interface-hyperlink",
  "interface-lighting-brightness",
  "interface-lock-closed",
  "interface-lock-open-unlock",
  "interface-login-key",
  "interface-search",
  "interface-setting-cog",
  "interface-share-megaphone-bullhorn",
  "interface-share-rocket",
  "interface-share-satellite",
  "interface-share-space-ship",
  "interface-share",
  "interface-signal-square",
  "interface-text-formatting-left-open-quote",
  "interface-text-formatting-right-close-quote",
  "interface-time-clock-circle",
  "interface-time-hour-glass",
  "interface-users-multiple",
  "interface-validation-checkbox-square",
  "interface-weather-moon",
  "legal-justice-hammer-gavel",
  "mail-chat-bubble-square",
  "mail-send-email-paper-airplane",
  "mail-send-envelope",
  "mail-sign-hashtag",
  "money-cashier-receipt",
  "money-currency-dollar-pay",
  "money-graph-arrow-increase",
  "money-graph-bar-chart-increase",
  "nature-ecology-leaf",
  "phone-telephone",
  "programming-bug",
  "programming-cloud",
  "programming-computer-database-server",
  "programming-computer-database",
  "programming-module-four-layout",
  "programming-module-three",
  "programming-module",
  "programming-script-code",
  "shopping-cart",
  "shopping-gift-present",
  "shopping-shipping-box-parcel-package",
  "tag-new-circle",
  "travel-map-earth-globe"
], a = [
  "arrow-chevron-down",
  "arrow-chevron-left",
  "arrow-chevron-right",
  "arrow-chevron-up",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "basic-shape-diamond",
  "basic-shape-hexagon",
  "basic-shape-primary-circle-ellipse-round",
  "basic-shape-primary-square-rectangle",
  "basic-shape-shield",
  "computer-device-desktop-monitor",
  "computer-device-desktop",
  "computer-device-laptop",
  "computer-device-mobile-phone-android-samsung-back",
  "computer-device-mobile-phone-android-samsung",
  "computer-device-mobile-phone-iphone-x-back",
  "computer-device-mobile-phone-iphone-x",
  "computer-device-mobile-tablet-touch",
  "computer-device-mobile-tablet",
  "computer-device-network-ethernet-cat6",
  "computer-device-network-lan-www",
  "computer-device-network-wifi-connection",
  "computer-device-network-wifi-router",
  "computer-keyboard-alt",
  "computer-keyboard-command-cmd-control-ctrl",
  "computer-keyboard-option",
  "computer-keyboard-shift",
  "ecology-science-erlenmeyer-flask",
  "entertainment-control-button-circle-left-arrow-rewind",
  "entertainment-control-button-circle-pause",
  "entertainment-control-button-circle-play",
  "entertainment-control-button-circle-right-arrow-fast-forward",
  "entertainment-control-button-circle-stop-square",
  "entertainment-party-popper-confetti",
  "image-flash-lightning",
  "image-photo-frame",
  "image-picture-flower",
  "interface-add-square",
  "interface-alert-error-exclamation-block-square",
  "interface-alert-error-x-block-square",
  "interface-alert-exclamation-diamond",
  "interface-alert-exclamation-triangle-warning",
  "interface-alert-information-circle",
  "interface-award-crown",
  "interface-bookmark-tag",
  "interface-bookmark",
  "interface-calendar-date-one",
  "interface-close",
  "interface-content-book-open-pages",
  "interface-content-book-page",
  "interface-content-file",
  "interface-content-folder",
  "interface-copy-clipboard",
  "interface-delete-bin-trash",
  "interface-dots-horizontal",
  "interface-dots-vertical",
  "interface-edit-attachment",
  "interface-edit-binocular",
  "interface-edit-magic-wand",
  "interface-edit-tool-eraser",
  "interface-edit-tool-paint-brush",
  "interface-edit-tool-paint-roller",
  "interface-edit-tool-pen",
  "interface-edit-tool-pencil",
  "interface-edit-view-eye",
  "interface-favorite-award",
  "interface-favorite-flag",
  "interface-favorite-heart",
  "interface-favorite-star",
  "interface-favorite-stars-shining",
  "interface-favorite-stars-sparkles",
  "interface-hierarchy-flowchart",
  "interface-home-house",
  "interface-hyperlink",
  "interface-lighting-brightness",
  "interface-lock-closed",
  "interface-lock-open-unlock",
  "interface-login-key",
  "interface-search",
  "interface-setting-cog",
  "interface-share-megaphone-bullhorn",
  "interface-share-rocket",
  "interface-share-satellite",
  "interface-share-space-ship",
  "interface-share",
  "interface-signal-square",
  "interface-text-formatting-left-open-quote",
  "interface-text-formatting-right-close-quote",
  "interface-time-clock-circle",
  "interface-time-hour-glass",
  "interface-users-multiple",
  "interface-validation-checkbox-square",
  "interface-weather-moon",
  "legal-justice-hammer-gavel",
  "mail-chat-bubble-square",
  "mail-send-email-paper-airplane",
  "mail-send-envelope",
  "mail-sign-hashtag",
  "money-cashier-receipt",
  "money-currency-dollar-pay",
  "money-graph-arrow-increase",
  "money-graph-bar-chart-increase",
  "nature-ecology-leaf",
  "phone-telephone",
  "programming-bug",
  "programming-cloud",
  "programming-computer-database-server",
  "programming-computer-database",
  "programming-module-four-layout",
  "programming-module-three",
  "programming-module",
  "programming-script-code",
  "shopping-cart",
  "shopping-gift-present",
  "shopping-shipping-box-parcel-package",
  "tag-new-circle",
  "travel-map-earth-globe"
], r = [
  "brand-adobe",
  "brand-amazon",
  "brand-browser-firefox",
  "brand-browser-googlechrome",
  "brand-creative-commons",
  "brand-ecommerce-etsy",
  "brand-ecommerce-patreon",
  "brand-ecommerce-shopify",
  "brand-ecommerce-wordpress",
  "brand-gaming-nintendo-switch",
  "brand-gaming-playstation",
  "brand-gaming-xbox-live",
  "brand-google-drive",
  "brand-google-gmail",
  "brand-google",
  "brand-music-itunes",
  "brand-music-soundcloud",
  "brand-music-spotify",
  "brand-office-dropbox",
  "brand-office-slack",
  "brand-office-zoom",
  "brand-payments-alipay",
  "brand-payments-paypal",
  "brand-payments-stripe",
  "brand-platform-android",
  "brand-platform-apple",
  "brand-platform-linux",
  "brand-platform-microsoft-windows",
  "brand-social-chat-discord",
  "brand-social-chat-kuaishou",
  "brand-social-chat-line",
  "brand-social-chat-messenger",
  "brand-social-chat-signal",
  "brand-social-chat-snapchat",
  "brand-social-chat-telegram",
  "brand-social-chat-wechat",
  "brand-social-chat-whatsapp",
  "brand-social-media-deviantart",
  "brand-social-media-dribbble",
  "brand-social-media-facebook",
  "brand-social-media-instagram",
  "brand-social-media-linkedin",
  "brand-social-media-pinterest",
  "brand-social-media-reddit",
  "brand-social-media-sina-weibo",
  "brand-social-media-threads",
  "brand-social-media-tiktok",
  "brand-social-media-tinder",
  "brand-social-media-tumblr",
  "brand-social-media-twitter",
  "brand-software-design-figma",
  "brand-software-development-authy",
  "brand-software-development-digital-ocean",
  "brand-software-development-docker",
  "brand-software-development-github",
  "brand-software-development-jira",
  "brand-software-development-openai",
  "brand-software-development-stackexchange",
  "brand-software-development-stackoverflow",
  "brand-video-netflix",
  "brand-video-twitch",
  "brand-video-vimeo",
  "brand-video-youtube",
  "programming-framework-angular",
  "programming-framework-astro",
  "programming-framework-laravel",
  "programming-framework-nextdotjs",
  "programming-framework-react",
  "programming-framework-vuedotjs",
  "programming-language-c",
  "programming-language-clojure",
  "programming-language-csharp",
  "programming-language-css3",
  "programming-language-go",
  "programming-language-html5",
  "programming-language-java",
  "programming-language-javascript-js",
  "programming-language-json",
  "programming-language-kotlin",
  "programming-language-node",
  "programming-language-objc",
  "programming-language-ocaml",
  "programming-language-php",
  "programming-language-powershell",
  "programming-language-python",
  "programming-language-r",
  "programming-language-ruby",
  "programming-language-scala",
  "programming-language-shell",
  "programming-language-swift",
  "programming-language-typescript",
  "programming-tool-git",
  "programming-tool-tailwindcss"
], t = {
  line: e,
  solid: a,
  brand: r
};
export {
  r as legacyBrandIconNames,
  t as legacyIconNames
};
